import "./styles/App.css";
import CredListView from "./components/CredListView";
import { Navigate, Route, Routes } from "react-router-dom";
import { Login, Signup } from "./pages";

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/credentials" element={<CredListView />} />
      </Routes>
    </div>
  );
};
export default App;